<div class="bcg p-4">
  <app-bulk-upload-estamp-step [currentStep]="1"></app-bulk-upload-estamp-step>
  <div class="upload-section mt-4">
    <div class="d-flex justify-content-end mb-3">
    <div class="download-template-wrapper" (clickOutside)="closeTemplateDropdown()">

      <!-- Split Button -->
      <div class="download-split-btn">
        <!-- Main action button -->
        <button
          class="download-main-btn"
          (click)="downloadTemplate()"
          title="{{ selectedServiceType ? 'Download ' + selectedServiceType + ' template' : 'Select a service type first' }}"
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
          <span>Download Template</span>
        </button>

        <!-- Chevron / dropdown toggle -->
        <button
          class="download-chevron-btn"
          (click)="toggleTemplateDropdown()"
          title="More options"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2.5"
               stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </button>
      </div>

      <!-- Dropdown Menu -->
      <div class="download-dropdown" *ngIf="showTemplateDropdown">
        <div class="download-dropdown-label">Download specific template</div>
        <button class="download-dropdown-item" (click)="downloadTemplate('eStamp')">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.8"
               stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="10" rx="2"/>
            <path d="M9 11V7a3 3 0 0 1 6 0v4"/>
          </svg>
          eStamp Template
        </button>
        <button class="download-dropdown-item" (click)="downloadTemplate('eSign')">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.8"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 17c2-2 4-4 6-3s2 4 4 3 3-4 5-5"/>
            <line x1="3" y1="21" x2="21" y2="21"/>
          </svg>
          eSign Template
        </button>
        <button class="download-dropdown-item" (click)="downloadTemplate('both')">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.8"
               stroke-linecap="round" stroke-linejoin="round">
            <polygon points="12 2 2 7 12 12 22 7 12 2"/>
            <polyline points="2 17 12 22 22 17"/>
            <polyline points="2 12 12 17 22 12"/>
          </svg>
          Both Template
        </button>
      </div>
    </div>
  </div>
    <div class="row align-items-center mb-2" style="margin-top: 45px">
      <div class="col-4">
        <h5 class="mb-1">Select Service Type</h5>
        <p style="font-size: 12px; color: #9ca3af; margin: 0;">Choose the service you want to process</p>
      </div>
      <div class="col-8">
        <div class="service-type-group">

          <label class="service-radio-label">
            <input
              type="radio"
              name="serviceType"
              value="eStamp"
              [(ngModel)]="selectedServiceType"
              (ngModelChange)="onServiceTypeChange($event)"
            />
            <div class="radio-card">
              <div class="radio-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="11" width="18" height="10" rx="2"/>
                  <path d="M9 11V7a3 3 0 0 1 6 0v4"/>
                  <line x1="12" y1="15" x2="12" y2="17"/>
                </svg>
              </div>
              <div class="radio-info">
                <span class="radio-title">eStamp</span>
                <span class="radio-sub">Electronic stamping</span>
              </div>
              <div class="radio-dot"></div>
            </div>
          </label>

          <label class="service-radio-label">
            <input
              type="radio"
              name="serviceType"
              value="eSign"
              [(ngModel)]="selectedServiceType"
              (ngModelChange)="onServiceTypeChange($event)"
            />
            <div class="radio-card">
              <div class="radio-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M3 17c2-2 4-4 6-3s2 4 4 3 3-4 5-5"/>
                  <line x1="3" y1="21" x2="21" y2="21"/>
                </svg>
              </div>
              <div class="radio-info">
                <span class="radio-title">eSign</span>
                <span class="radio-sub">Digital Signing</span>
              </div>
              <div class="radio-dot"></div>
            </div>
          </label>

          <label class="service-radio-label">
            <input
              type="radio"
              name="serviceType"
              value="both"
              [(ngModel)]="selectedServiceType"
              (ngModelChange)="onServiceTypeChange($event)"
            />
            <div class="radio-card">
              <div class="radio-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <polygon points="12 2 2 7 12 12 22 7 12 2"/>
                  <polyline points="2 17 12 22 22 17"/>
                  <polyline points="2 12 12 17 22 12"/>
                </svg>
              </div>
              <div class="radio-info">
                <span class="radio-title">Both</span>
                <span class="radio-sub">eSign &amp; eStamp</span>
              </div>
              <div class="radio-dot"></div>
            </div>
          </label>

        </div>
      </div>
    </div>

    <div class="service-upload-divider" *ngIf="selectedServiceType"></div>

    <!-- Upload Excel row — only visible after a service type is selected -->
    <div class="row align-items-center mb-4" *ngIf="selectedServiceType">
      <div class="col-4">
        <h5 class="mb-0">Upload your Excel</h5>
        <p style="font-size: 12px; color: #9ca3af; margin: 0;">Upload the filled template file</p>
      </div>
      <div class="col-4">
        <button
          class="btn btn-upload d-inline-flex align-items-center gap-2"
          (click)="openUploadModal()"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17,8 12,3 7,8" />
            <line x1="12" y1="3" x2="12" y2="15" />
          </svg>
          <span>Upload Excel</span>
        </button>

        <!-- Confirmed file pill -->
        <div
          *ngIf="isFileConfirmed && uploadedExcelFile"
          class="mb-3"
          style="margin-top: 15px"
        >
          <div
            class="d-inline-flex align-items-center gap-2 px-3 py-2 bg-light border rounded"
            style="font-size: 13px"
          >
            <i
              class="pi pi-file-excel"
              style="color: #217346; font-size: 16px"
            ></i>
            <span class="fw-medium">{{ excelFileName }}</span>
            <span class="text-muted">•</span>
            <span class="text-muted"
              >{{ validationResult?.fileCount }} files</span
            >
            <app-button
              label="View"
              variant="primary"
              size="md"
              (clicked)="viewUploadedExcel(viewExcelModal)"
            ></app-button>
            <button
              class="btn btn-sm btn-link text-danger p-0 ms-1"
              (click)="removeConfirmedFile()"
              title="Remove file"
              style="font-size: 14px; line-height: 1"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
        </div>

        <!-- Inline API error block shown below the file pill -->
        <div
          *ngIf="apiInlineError"
          style="
            margin-top: 12px;
            padding: 12px 15px;
            background-color: #fff3cd;
            border: 1px solid #ffc107;
            border-left: 4px solid #e65100;
            border-radius: 6px;
            max-width: 480px;
          "
        >
          <div style="display: flex; align-items: flex-start; gap: 8px">
            <i
              class="pi pi-exclamation-triangle"
              style="
                color: #e65100;
                font-size: 16px;
                margin-top: 1px;
                flex-shrink: 0;
              "
            ></i>
            <div>
              <strong
                style="
                  color: #7a3d00;
                  font-size: 13px;
                  display: block;
                  margin-bottom: 3px;
                "
              >
                Submission Failed
              </strong>
              <span style="color: #5c3000; font-size: 13px; line-height: 1.5">
                {{ apiInlineError }}
              </span>
              <div style="margin-top: 8px; font-size: 12px; color: #7a3d00">
                Please fix the issue in your Excel file and upload again.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4"></div>
    </div>

    <div class="text-end mt-3">
      <button
        class="btn btn-place-order"
        [disabled]="!isFileConfirmed || isProcessing"
        (click)="proceedToUpload()"
      >
        <i *ngIf="isProcessing" class="pi pi-spin pi-spinner"></i>
        {{ isProcessing ? "Getting Upload URLs..." : "Next" }}
      </button>
    </div>
  </div>

  <!-- Upload Modal -->
  <div
    class="modal-overlay"
    *ngIf="showUploadModal"
    (click)="closeUploadModal()"
  >
    <div
      class="upload-modal"
      (click)="$event.stopPropagation()"
      style="max-width: 600px"
    >
      <div class="modal-header">
        <h5 class="modal-title">
          Upload Document <span class="text-danger">*</span>
        </h5>
        <button class="close-button" (click)="closeUploadModal()">×</button>
      </div>

      <div class="modal-body">
        <input
          type="file"
          #fileInput
          accept=".xlsx,.xls"
          style="display: none"
          (change)="onExcelFileSelect($event)"
        />

        <div
          class="drop-zone"
          (drop)="onDrop($event)"
          (dragover)="onDragOver($event)"
          (click)="fileInput.click()"
          [class.has-file]="uploadedExcelFile"
          style="
            cursor: pointer;
            padding: 30px;
            border: 2px dashed #ccc;
            border-radius: 8px;
            text-align: center;
            background-color: #f9f9f9;
            transition: all 0.3s ease;
          "
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="text-muted"
            style="margin: 0 auto 10px; display: block"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17,8 12,3 7,8" />
            <line x1="12" y1="3" x2="12" y2="15" />
          </svg>
          <p
            class="drop-zone-text"
            style="margin: 5px 0; font-size: 14px; color: #666"
          >
            Drop your files here
          </p>
          <p class="drop-zone-link" style="margin: 5px 0; font-size: 13px">
            or
            <a
              href="javascript:void(0)"
              style="color: #6366f1; text-decoration: none"
              >click to select file</a
            >
          </p>
          <p
            class="drop-zone-info"
            style="margin: 5px 0; font-size: 12px; color: #999"
          >
            Supported format: XLSX, up to 10 MB
          </p>
        </div>

        <!-- Selected File Display -->
        <div *ngIf="uploadedExcelFile" style="margin-top: 20px">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 12px;
              background-color: #f0f0f0;
              border-radius: 6px;
              margin-bottom: 15px;
            "
          >
            <div style="display: flex; align-items: center">
              <i
                class="pi pi-file-excel"
                style="color: #217346; font-size: 20px; margin-right: 10px"
              ></i>
              <span style="font-size: 14px; font-weight: 500">{{
                excelFileName
              }}</span>
            </div>
            <button
              class="btn btn-sm btn-danger"
              (click)="removeExcelFile(); $event.stopPropagation()"
              style="padding: 4px 8px; font-size: 12px"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>

          <!-- Validation Loading -->
          <div *ngIf="isValidating" style="text-align: center; padding: 20px">
            <i
              class="pi pi-spin pi-spinner"
              style="font-size: 24px; color: #6366f1"
            ></i>
            <p style="margin-top: 10px; color: #666">
              Validating Excel data...
            </p>
          </div>

          <!-- Validation Success -->
          <div
            *ngIf="
              !isValidating && validationResult && validationResult.isValid
            "
            style="
              padding: 15px;
              background-color: #d4edda;
              border: 1px solid #c3e6cb;
              border-radius: 6px;
              margin-bottom: 15px;
            "
          >
            <div
              style="display: flex; align-items: center; margin-bottom: 10px"
            >
              <i
                class="pi pi-check-circle"
                style="color: #155724; font-size: 18px; margin-right: 8px"
              ></i>
              <strong style="color: #155724"
                >No issue found in the excel data uploaded.</strong
              >
            </div>

            <!-- Summary Information -->
            <div
              style="
                margin-top: 15px;
                padding-top: 15px;
                border-top: 1px solid #c3e6cb;
              "
            >
              <div
                style="
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  gap: 12px;
                  font-size: 13px;
                "
              >
                <div>
                  <strong style="color: #155724">Total Rows:</strong>
                  <span style="margin-left: 5px">{{ validRowCount }}</span>
                </div>

                <!-- hide Total Stamp Amount for eSign only -->
                <div *ngIf="selectedServiceType !== 'eSign'">
                  <strong style="color: #155724">Total Stamp Amount:</strong>
                  <span style="margin-left: 5px">{{
                    getTotalStampAmount()
                  }}</span>
                </div>
              </div>

              <!-- Additional Info if available -->
              <div
                style="margin-top: 12px; font-size: 13px"
                *ngIf="getBranchCode()"
              >
                <div
                  style="
                    margin-bottom: 8px;
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 12px;
                    font-size: 13px;
                  "
                >
                  <div>
                    <strong style="color: #155724">Branch Code:</strong>
                    <span style="margin-left: 5px">{{ getBranchCode() }}</span>
                  </div>
                  <div>
                    <strong style="color: #155724">Requested By:</strong>
                    <span style="margin-left: 5px">{{ getRequestedBy() }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Validation Errors -->
          <div
            *ngIf="
              !isValidating &&
              validationResult &&
              !validationResult.isValid &&
              consolidatedErrors.length > 0
            "
            style="
              padding: 15px;
              background-color: #f8d7da;
              border: 1px solid #f5c6cb;
              border-radius: 6px;
              margin-bottom: 15px;
            "
          >
            <div
              style="display: flex; align-items: center; margin-bottom: 10px"
            >
              <i
                class="pi pi-exclamation-triangle"
                style="color: #721c24; font-size: 18px; margin-right: 8px"
              ></i>
              <strong style="color: #721c24">
                {{ consolidatedErrors.length }}
                {{ consolidatedErrors.length === 1 ? "issue" : "issues" }}
                found in the excel data uploaded.
              </strong>
            </div>

            <!-- Duplicate file name errors inline -->
            <div
              *ngIf="fileNameDuplicateErrors.length > 0"
              style="
                margin-bottom: 12px;
                padding: 10px 12px;
                background-color: #fce8e8;
                border: 1px solid #f1aeb5;
                border-left: 3px solid #dc3545;
                border-radius: 4px;
              "
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  gap: 6px;
                  margin-bottom: 6px;
                "
              >
                <i
                  class="pi pi-copy"
                  style="color: #dc3545; font-size: 14px"
                ></i>
                <strong style="color: #58151c; font-size: 13px">
                  Duplicate File Names Detected
                </strong>
              </div>
              <ul
                style="
                  margin: 0;
                  padding-left: 18px;
                  font-size: 12px;
                  color: #58151c;
                "
              >
                <ng-container
                  *ngFor="let err of fileNameDuplicateErrors; let i = index"
                >
                  <li
                    *ngIf="
                      i === 0 ||
                      fileNameDuplicateErrors[i].error !==
                        fileNameDuplicateErrors[i - 1].error
                    "
                    style="margin-bottom: 3px"
                  >
                    {{ err.error }}
                  </li>
                </ng-container>
              </ul>
            </div>

            <div
              *ngIf="validRowCount > 0"
              style="margin-top: 10px; color: #721c24; font-size: 13px"
            >
              {{ validRowCount }} valid rows can be processed.
            </div>

            <div
              *ngIf="validRowCount === 0"
              style="
                margin-top: 10px;
                color: #721c24;
                font-weight: bold;
                font-size: 13px;
              "
            >
              Please correct and upload again.
            </div>

            <!-- View Issues Button -->
            <div
              style="
                margin-top: 15px;
                display: flex;
                justify-content: space-between;
              "
            >
              <button
                class="btn btn-danger viewIssues"
                (click)="viewIssues(issueListModal)"
                style="padding: 6px 12px; font-size: 13px"
              >
                View Issues
              </button>

              <!-- Skip and Continue Button -->
              <button
                *ngIf="validRowCount > 0 && !issuesSkipped && selectedServiceType === 'eStamp'"
                (click)="skipAndContinue()"
                class="btn btn-skip-and-continue ms-2"
                style="padding: 6px 12px; font-size: 13px"
              >
                Skip and Continue
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-cancel" (click)="closeUploadModal()">
          Cancel
        </button>
        <button
          class="btn btn-upload-confirm"
          [disabled]="
            !uploadedExcelFile ||
            !validationResult ||
            !validationResult.isValid ||
            isValidating
          "
          (click)="confirmUpload()"
        >
          Upload
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Issues Modal Template -->
<ng-template #issueListModal let-modal>
  <div class="modal-header">
    <strong>Issues in Excel file</strong>
    <button
      type="button"
      class="close-button"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body">
    <div class="container">
      <div class="d-flex justify-content-between mb-3">
        <div>
          <span class="title_header">Order Summary</span>
        </div>
      </div>

      <!-- Summary Info -->
      <div class="row">
        <div class="col">
          <div class="r1">
            Total Rows:<span class="r1s">{{ convertedData.length }}</span>
          </div>
        </div>
        <div class="col">
          <div class="r1">
            Total Amount:
            <span class="r1s">{{ totalStampAmountForPopup }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="r1">
            Errors:
            <span class="r1s">{{ consolidatedErrors.length }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="r1">
            Requested By: <span class="r1s">{{ getRequestedBy() }}</span>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between mb-3 mt-4">
        <div>
          <span class="title_header">Errors Table</span>
        </div>
      </div>

      <!-- Dynamic error table — uses cached errorTableColumns property (no CD freeze) -->
      <div class="my-3">
        <app-data-table
          [columns]="errorTableColumns"
          [data]="rowsWithIssues"
          [paginator]="false">
        </app-data-table>
      </div>

      <!-- Consolidated Errors List -->
      <div
        class="my-3"
        style="max-height: 20rem; overflow-y: scroll; margin: 2px"
      >
        <p
          style="color: #2f2f2f; margin-bottom: 5px"
          *ngFor="let item of consolidatedErrors"
        >
          {{ item.displayText }}
        </p>
      </div>

      <div class="row mt-2">
        <div class="col-lg-2 col-sm-2 col-md-2 offset-10">
          <div class="text-right custom_button">
            <p-button
              label="Okay"
              (click)="modal.dismiss('Cross click')"
              styleClass="p-button-sm-outline"
            >
            </p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewExcelModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">View Bulk Data</h4>
    <app-button
      icon="times"
      [iconOnly]="true"
      [iconOnlyBorderless]="true"
      variant="outline"
      size="sm"
      ariaLabel="Close"
      title="Close"
      (clicked)="modal.dismiss('Cross click')"
    ></app-button>
  </div>
  <div class="modal-body">
    <app-data-table
      [columns]="errorTableColumns"
      [data]="validationResult?.data || []"
      [paginator]="true"
    ></app-data-table>
  </div>
</ng-template>
